import Dropdown from "@common/components/Dropdown/Dropdown";
import Paragraph from "@common/components/Paragraph/Paragraph";
import BaseTooltip from "@common/components/Tooltip/Tooltip";
import { vars } from "@common/styles";
import styled from "styled-components";

export const UserModeDropdown = styled(Dropdown)`
  background: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey90};
  border-radius: 1rem;

  > div:first-child {
    padding: 1rem;
  }

  span {
    color: ${vars.colors.grey30};
    white-space: nowrap;
  }
`;

export const ModeIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1.4rem;
`;

export const Subtitle = styled(Paragraph)`
  margin-left: 2rem;
  margin-bottom: 0.8rem;
`;

export const UserTooltip = styled(BaseTooltip)`
  width: 12.5rem;
`;
